module.exports = __webpack_public_path__ + "img/map.045f414f.jpg";